import { BaseService } from 'src/app/services/base/base.service';
import { Historico } from '../models/historico.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RespostaService {


  private modelName = 'resposta';
  constructor(
    protected http: HttpClient,
    private baseService: BaseService
  ) {
  }

  get urlApi() {
    return environment.apiEndpoint + this.modelName;
  }

  salvarResposta(model: {chave: string, idTipoLider: number, respostas: {id1: number, id2?: number}[]}): Observable<Historico> {
    return this.http.post<any>(`${environment.apiEndpoint}/${this.modelName}/`, model, { headers: this.baseService.createHeader });
  }

  getExistHistoricToUser(): Observable<any> {
    return this.http.get<any>(`${environment.apiEndpoint}/${this.modelName}/exist-historic-user`, { headers: this.baseService.createHeader });
  }
}
